export const RETRIEVE_REDACTION_STATUSES = `
  query retrieveRedactionStatuses($schemaId: ID!, $offset: Int, $limit: Int) {
    structuredDataObjects(schemaId: $schemaId, offset: $offset, limit: $limit) {
      count
      records {
        id
        createdDateTime
        modifiedDateTime
        data
      }
    }
  }
`;

export const saveRedactionStatusQuery = `
  mutation saveRedactionStatus($id: ID!, $schemaId: ID!, $data: JSONData!) {
    createStructuredData(input: {
      id: $id,
      schemaId: $schemaId,
      data: $data
    }) {
      id
      data
      createdDateTime
      modifiedDateTime
    }
  }
`;

export interface SaveRedactionStatusResponse {
  readonly createStructuredData: {
    readonly id: string;
    readonly data: Record<string, unknown>;
    readonly createdDateTime: string;
    readonly modifiedDateTime: string;
  };
}

// Deleting a custom status is normally a soft delete — an upsert writing
// `isDeleted: true` via saveRedactionStatusQuery — so files still tagged
// with it keep resolving its attributes. This hard delete backs the
// "permanently delete" action in the deleted-statuses view only.
export const permanentlyDeleteRedactionStatusQuery = `
  mutation deleteRedactionStatus($sdoId: ID!, $schemaId: ID!) {
    deleteStructuredData(input: {
      id: $sdoId,
      schemaId: $schemaId
    }) {
      id
    }
  }
`;

export interface DeleteRedactionStatusResponse {
  readonly deleteStructuredData: {
    readonly id: string;
  };
}
